/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-vars */
export const coalesce = (...strs) => {
  const stringValida = strs.find((str) => !!str && str.trim());

  return stringValida || 'N/I';
};

const StringFilter = {
  install(Vue) {
    Vue.filter('StringEmptyFilter', coalesce);
  },
};

export default StringFilter;
